<script lang="ts">
export default {
    name: 'BaseDropArea',
};
</script>

<script setup lang="ts">
withDefaults(defineProps<{
    visible?: boolean;
    text?: string;
}>(), {
    text: '',
});
</script>

<template>
    <div
        v-show="visible"
        class="absolute inset-0 zi-10 flex items-center justify-center overflow-hidden rounded-[inherit] bg-white/25 backdrop-blur-xs backdrop-filter"
    >
        <span class="text-2xl font-semibold text-gray-600 font-avenir">{{ text }}</span>
    </div>
</template>
